<pw-view-title>Projektststatus</pw-view-title>
<pw-view-actions>
  <button mat-button (click)="createProjectStatus()">
    <mat-icon>add</mat-icon>
  </button>
</pw-view-actions>

<mat-card *ngIf="currentStatus">
  <mat-card-title>
    <button *ngIf="index < size - 1" mat-button color="primary" (click)="increment()">
      <mat-icon>chevron_left</mat-icon>
    </button>
    {{currentStatus?.TIMELABEL}}
    <button *ngIf="index > 0" mat-button color="primary" (click)="decrement()">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </mat-card-title>
  <mat-card-content>
    <div class="ps-grid-4-col">

      <mat-form-field>
        <mat-label>Abnahmetermin</mat-label>
        <input matInput [matDatepicker]="pickerAcceptance" (dateChange)="onValueChange($event)"
               [(ngModel)]="currentStatus.DATE_ACCEPTANCE">
        <mat-datepicker-toggle matIconSuffix [for]="pickerAcceptance"></mat-datepicker-toggle>
        <mat-datepicker #pickerAcceptance></mat-datepicker>
      </mat-form-field>
      <div [ngClass]="isChanged('DATE_ACCEPTANCE') ? 'changed':''">{{previousStatus.DATE_ACCEPTANCE | date}}</div>

      <mat-form-field>
        <mat-label>Späteste Freigabe Konstruktion</mat-label>
        <input matInput [matDatepicker]="pickerLatestReleaseConst"
               [(ngModel)]="currentStatus.DATE_LATEST_RELEASE_CONST" (dateChange)="onValueChange($event)">
        <mat-datepicker-toggle matIconSuffix [for]="pickerLatestReleaseConst"></mat-datepicker-toggle>
        <mat-datepicker #pickerLatestReleaseConst></mat-datepicker>
      </mat-form-field>
      <div
        [ngClass]="isChanged('DATE_LATEST_RELEASE_CONST') ? 'changed':''">{{previousStatus.DATE_LATEST_RELEASE_CONST | date}}</div>

      <mat-form-field>
        <mat-label>Späteste Freigabe Spezifikation</mat-label>
        <input matInput [matDatepicker]="pickerLatestReleaseSpec" (dateChange)="onValueChange($event)"
               [(ngModel)]="previousStatus.DATE_LATEST_RELEASE_SPEC">
        <mat-datepicker-toggle matIconSuffix [for]="pickerLatestReleaseSpec"></mat-datepicker-toggle>
        <mat-datepicker #pickerLatestReleaseSpec></mat-datepicker>
      </mat-form-field>
      <div
        [ngClass]="isChanged('DATE_LATEST_RELEASE_SPEC') ? 'changed':''">{{previousStatus.DATE_LATEST_RELEASE_SPEC | date}}</div>

      <mat-form-field>
        <mat-label>Kickoff</mat-label>
        <input matInput [matDatepicker]="pickerKickoff" [(ngModel)]="currentStatus.DATE_KICKOFF"
               (dateChange)="onValueChange($event)">
        <mat-datepicker-toggle matIconSuffix [for]="pickerKickoff"></mat-datepicker-toggle>
        <mat-datepicker #pickerKickoff></mat-datepicker>
      </mat-form-field>
      <div [ngClass]="isChanged('DATE_KICKOFF') ? 'changed':''">{{previousStatus.DATE_KICKOFF | date}}</div>

    </div>
  </mat-card-content>
  <mat-card-actions align="end">
    <button *ngIf="index === 0 && change" mat-button color="primary" (click)="patchProjectStatus()"
            matTooltip="Speichern">
      <mat-icon>save</mat-icon>
    </button>
  </mat-card-actions>
</mat-card>

<mat-card *ngIf="!currentStatus">
  <mat-card-content>
    Noch kein Projektstatus vorhanden.
  </mat-card-content>
</mat-card>


